import { render, staticRenderFns } from "./AddEdit.vue?vue&type=template&id=968d0bc4&scoped=true"
import script from "./AddEdit.vue?vue&type=script&lang=js"
export * from "./AddEdit.vue?vue&type=script&lang=js"
import style0 from "./AddEdit.vue?vue&type=style&index=0&id=968d0bc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "968d0bc4",
  null
  
)

export default component.exports